import {
    RESERVE_ACTIVATION_REQUEST,
    RESERVE_ACTIVATION_SUCCESS,
    RESERVE_ACTIVATION_ERROR,
} from 'state/actions/reserve_activation'

const initialState = {
    submitting: false,
    errorMessage: '',
}


export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case RESERVE_ACTIVATION_REQUEST:
        return {
            ...state,
            submitting: true,
            errorMessage: '',
        }
    case RESERVE_ACTIVATION_SUCCESS:
        return {
            ...state,
            submitting: false,
        }
    case RESERVE_ACTIVATION_ERROR:
        return {
            ...state,
            submitting: false,
            errorMessage: action.payload.errorMessage,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/reserve_activation.js